if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

// !important Only in view git us feedback (anonymous feedback)
const EMAIL_FIELD = document.querySelector('[name="email_address"]')
const NAME_FIELD = document.querySelector('[name="name_"]')
const CHECKBOX_ANONYMOUS = document.querySelectorAll('[name="would_you_like_to_remain_anonymous_[]"]')
const hiddenFieldsForm = () => {
	if (EMAIL_FIELD && CHECKBOX_ANONYMOUS[0] && CHECKBOX_ANONYMOUS[1]) {
		CHECKBOX_ANONYMOUS[0].addEventListener('click', (e) => {
			changeValueEmail(e.target.checked, 0)
		})
		CHECKBOX_ANONYMOUS[1].addEventListener('click', (e) => {
			changeValueEmail(e.target.checked, 1)
		})
	}
}
// !important change value to inputs by send anonymous form
const changeValueEmail = (checkbox, input) => {
	if (checkbox && input === 0) {
		EMAIL_FIELD.setAttribute("value", "versallesfeedback@gmail.com")
		NAME_FIELD.setAttribute("value", "anonymous name")
	} else if ( !checkbox &&  input === 0){
		EMAIL_FIELD.setAttribute("value", "")
		NAME_FIELD.setAttribute("value", "")
	}
	if ( input === 1 ) {
		EMAIL_FIELD.setAttribute("value", "")
		NAME_FIELD.setAttribute("value", "")
	}
}

if (window.location.pathname === "/give-us-feedback" ) {
	hiddenFieldsForm()
}
let images = document.querySelectorAll('.change-state')
const chageState = () => {
	if (images) {
		images.forEach(element => {
			let srcDarkMode = element.dataset.darkMode
			let srcLightMode = element.dataset.lightMode
			let src = element.src
			if (src === srcDarkMode) {
				element.src = srcLightMode
			} else {
				element.src = srcDarkMode
			}
		});
	}
}

(function(){
	
    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//circle button hover states
	const all_btns = document.querySelectorAll('.btn');
	for (let i = 0; i < all_btns.length; i++) {
		let extra_btn_copy = all_btns[i].textContent;
		all_btns[i].innerHTML = extra_btn_copy+'<span class="mask-copy">'+extra_btn_copy+'</span>';  
	}

	const home_header = document.querySelectorAll('.home-header-js');
	for (let i = 0; i < home_header.length; i++) {
		let home_header_copy = home_header[i].textContent;
		home_header[i].innerHTML = home_header_copy+'<span class="header-mask-copy">'+home_header_copy+'</span>';
	}

	const home_gallery = document.querySelectorAll('.home-gallery-js');
	for (let i = 0; i < home_gallery.length; i++) {
		let home_gallery_copy = home_gallery[i].textContent;
		home_gallery[i].innerHTML = home_gallery_copy+'<span class="gallery-mask-copy">'+home_gallery_copy+'</span>';
	}

	//header scroll
	let scrollpos = window.scrollY
	const full_header = document.querySelector('.header');

	window.addEventListener('scroll', function() { 
		scrollpos = window.scrollY;

		if (scrollpos >= 80) { 
			full_header.classList.remove("up"),
			full_header.classList.add("down")
		}
		else { 
			full_header.classList.remove("down"),
			full_header.classList.add("up")
		}

		//console.log(scrollpos)
	});

	const intro_content = document.querySelector('.intro-copy__copy-holder');

	if(intro_content){
		document.getElementsByClassName('intro-copy__copy-holder')[0].classList.add('appear');
	}

    const animateHTML = function () {
        let elems,
            windowHeight;
        let init = function () {
            elems = document.getElementsByClassName('hide-object');
            windowHeight = window.innerHeight;
            addEventHandlers();
        };
        let addEventHandlers = function () {
            window.addEventListener('scroll', checkPosition);
            window.addEventListener('resize', init);
        };
        let checkPosition = function () {
            for (let i = 0; i < elems.length; i++) {
                let posFromTop = elems[i].getBoundingClientRect().top;
                if (posFromTop - windowHeight <= 0) {
                    elems[i].className = elems[i].className.replace('hide-object', 'show-object')
                }
            }
        };
        return {
            init: init
        }
    };
    animateHTML().init();

	// intro loader
	function animateValue(obj, start, end, duration) {
		let startTimestamp = null;
		const step = (timestamp) => {
			if (!startTimestamp) startTimestamp = timestamp;
			const progress = Math.min((timestamp - startTimestamp) / duration, 1);
			if (obj) {
				
				obj.innerHTML = Math.floor(progress * (end - start) + start);
			}
			if (progress < 1) {
				window.requestAnimationFrame(step);
			}
		};
		window.requestAnimationFrame(step);
	}
	  
	const obj = document.getElementById("value-intro");
	animateValue(obj, 0, 100, 4000);
	

    let hour = new Date().getHours();
	let $new_mode = '';

	$('.switch input').change(function(e) {
		e.preventDefault();
		$('body').toggleClass('nighttime');
		chageState();
		//console.log('test');
		if($('body').hasClass('nighttime')) {
			$new_mode = 'nighttime';
			$('body').addClass('nighttime');
			$('.switch input').prop("checked", false);

		} else {
			$new_mode = 'daytime';
			$('body').removeClass('nighttime');
			$('.switch input').prop("checked", true);
		}
		localStorage.setItem("body", $new_mode);
	}); 

	if (hour > 16 || hour < 8) { 
		$('body').addClass('nighttime'); 
		$('.switch input').prop("checked", false);
	} else {
		$('.switch input').prop("checked", true);
	}

	if(localStorage.getItem('body') == 'nighttime') {
		$('body').addClass('nighttime');
		$('.switch input').prop("checked", false);
	} else {
		$('body').removeClass('nighttime');
		$('.switch input').prop("checked", true);
	}

	let events = $('.single-quads__each-quad');
	$(".tabs li a").on('click', function (e) {
		e.preventDefault();
		let $this = $(this);
		let cat = $this.data('category-type');
		if ($this.hasClass('see-all')) {
			$('.single-quads__each-quad').show();
		} else {
			events.filter(':visible').hide();
			events.filter('[data-category-type="'+cat+'"]').show();
		}
		$('.tabs li a').removeClass('active');
		$this.addClass('active');
	});	

	$('.sym-slides').slick({
        accessibility: false
    });

	let $slick_home = $('.home-hero-js');
	//$('.home-hero-js').slick('unslick');

	$slick_home.on('afterChange', function(event, slick, currentSlide){
		$('.home-hero-js .slick-slide:not(.slick-active) span').removeClass('animate-slide--grow');
		$('.home-hero-js .slick-slide.slick-active span').addClass('animate-slide--shrink');
	})
	.on('beforeChange', function(event, slick, currentSlide){
		$('.home-hero-js .slick-slide:not(.slick-active) span').addClass('animate-slide--shrink');
		$('.home-hero-js .slick-slide.slick-active span').removeClass('animate-slide--grow');
	})
	.slick({
		autoplay: true,
		arrows: true,
		dots: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		draggable: false,
		infinite: true,
		pauseOnHover: false,
		swipe: false, 
		touchMove: false,
		vertical: true,
		speed: 2500,
		useTransform: true,
		cssEase: 'ease-in-out',
		adaptiveHeight: true,
		centerMode: true,
		centerPadding: '0px',
		accessibility: false
	});

	let $slick_large = $('.large-slider-js');

	$slick_large.on('afterChange', function(event, slick, currentSlide){
		$('.large-slider-js .slick-slide:not(.slick-active) h2 .header-mask').addClass('show-object');
		$('.large-slider-js .slick-slide.slick-active h2 .header-mask').removeClass('hide-object');
	})
	.on('beforeChange', function(event, slick, currentSlide){
		$('.large-slider-js .slick-slide:not(.slick-active) h2 .header-mask').addClass('hide-object');
		$('.large-slider-js .slick-slide.slick-active h2 .header-mask').removeClass('show-object');
	})
	.slick({ 
		arrows: true, 
		dots: true, 
		autoplay: true, 
		autoplaySpeed: 6000, 
		accessibility: false, 
		fade: true,
		//centerMode: true,
		infinite: true, 
		speed: 500,
		pauseOnHover: false
		//useTransform: true,
		//cssEase: 'ease-in-out',
	});

	$('.rectangular-slider-js').slick({
		fade: true,
		accessibility: false
	});

	$('.fancybox').fancybox({});

	$('.tabs-events li').on('click', function () {

		var ourClass = $(this).attr('class');
		$('.tabs-events li').removeClass('active');
		$(this).addClass('active');

		if($(this).hasClass('all')) {
			$('.events-block').children('article').show();
		} else {
			$('.events-block').children('article:not(.' + ourClass + ')').hide();
			$('.events-block').children('article.' + ourClass).show();
		}
		return false;
	});

})();